"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Quote } from "lucide-react";
export default function LeadershipVision() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="leadership-vision" className="bg-background w-full">
      <div className="bg-muted w-full py-20 lg:py-32">
        <div className="container mx-auto px-6 md:px-8 max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
            
            {}
            <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="mb-6">
                <span className="text-primary font-semibold tracking-wider uppercase text-sm mb-4 block">
                  Mission First
                </span>
                <h2 className="text-4xl md:text-5xl font-bold text-foreground tracking-tight leading-tight mb-8">
                  Digital Sovereignty for the Modern State
                </h2>
              </div>

              <Quote className="size-10 text-primary/20 mb-6" aria-hidden="true" />

              <div className="space-y-6 text-lg md:text-xl text-muted-foreground font-sans leading-relaxed">
                <p>In an era where data is a nation's most critical asset, relying on fragmented, legacy systems is a vulnerability we can no longer afford. With Kanha ERP, our mission is to empower public institutions with true digital sovereignty.</p>
                <p>
                  We build secure, scalable, and transparent infrastructure that puts control firmly back in the hands of the government and its citizens. Our platform transcends basic operational efficiency; it is designed to secure the future of public administration against evolving global threats while ensuring absolute regulatory compliance.
                </p>
                <p>
                  The transition to a unified digital ecosystem is not merely a technological upgrade—it is a fundamental requirement for maintaining institutional trust and operational excellence in the 21st century.
                </p>
              </div>

              <div className="mt-10 pt-8 border-t border-border/50">
                <p className="font-bold text-2xl text-foreground tracking-tight">
                  Orland Yee
                </p>
                <p className="text-primary font-medium mt-1">CEO &amp; President, Kanha Technology Solutions</p>
              </div>
            </div>

            {}
            <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="relative aspect-[4/5] w-full max-w-md mx-auto lg:max-w-none lg:ml-auto">
                {}
                <div className="absolute inset-0 bg-primary/5 rounded-[8px] translate-x-4 translate-y-4 -z-10" />
                
                <img src="https://unified-warthog.10web.cloud/wp-content/uploads/2026/03/Orland-at-Cannabis-Research-Conference-1.jpg" alt="Orland Yee, CEO and President of Kanha ERP" className="w-full h-full object-cover rounded-[8px] shadow-xl border border-border/50" loading="lazy" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}